import styled from "styled-components";
import Icon from "../Icon/Icon";

const PAYMENT_BUTTON_VERTICAL_PADDING = "24px";
const PAYMENT_FOOTER_CONTENT_GAP = "40px";
const ARTICLE_LINK_ROW_GAP = "8px 16px";

// The coin, in the label's colour.
export const PayIcon = styled(Icon)`
  width: 18px;
  height: 18px;
  background-color: currentColor;
`;

export const PaymentButtonSlot = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: auto;
  padding: ${PAYMENT_BUTTON_VERTICAL_PADDING} 0;
`;

export const PaymentFooterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${PAYMENT_FOOTER_CONTENT_GAP};
`;

export const PaymentPolicyLinksContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const PaymentPolicyLinksList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: ${ARTICLE_LINK_ROW_GAP};
`;
